import React from 'react'
import { useQuery } from '@apollo/client';
import { LATEST_BLOG_POSTS } from '../../utils/constants/queries';
import { ErrorComponent, LatestBlog } from '../../components/';
export default function LatestPosts() {
    const { loading, error, data } = useQuery(LATEST_BLOG_POSTS);
    const postsWidget =  (loading) ? <p>Loading...</p>:
        error? <ErrorComponent message ={error.message}/>:
        data.blog.map((post)=>
        <LatestBlog key ={post.id} post ={post}/>
        )  
    return (
        <section className="widget widget_huruma_posts_thumb">
            <h3 className="widget-title">Popular Posts</h3>
            {postsWidget}
        </section>
    )
}
